module.exports = __webpack_public_path__ + "static/media/iconThree.364f641d.svg";